import { render, staticRenderFns } from "./DirectionContactModal.vue?vue&type=template&id=ed429e9c&"
import script from "./DirectionContactModal.vue?vue&type=script&lang=js&"
export * from "./DirectionContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed429e9c')) {
      api.createRecord('ed429e9c', component.options)
    } else {
      api.reload('ed429e9c', component.options)
    }
    module.hot.accept("./DirectionContactModal.vue?vue&type=template&id=ed429e9c&", function () {
      api.rerender('ed429e9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/DirectionContactModal.vue"
export default component.exports